import JobTimelineEntry from './JobTimelineEntry';

export default JobTimelineEntry;
